import React from 'react'
import '../AttendancePlatform/Attendance.css'
import screenshotOne from '../../Assets/screenshot_ap_one.png'
import screenshotTwo from '../../Assets/screenshot_ap_two.png'
import screenshotThree from '../../Assets/screenshot_ap_three.png'
import { APNavBar } from './components/APNavBar.js'

export const AttendanceComponent = () => {
 
  return (
    <>
     <div style={{ backgroundColor: 'white' }}>
     <APNavBar visibleNavLinks = {true}/>


     
     <section id="features1" >
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6 col-md-6">
                    <img src={screenshotOne} alt=""/>
                </div>
                <div class="col-12 col-lg-6 col-md-6 d-flex flex-column my-auto">
                    <h2><span class="text-green"> Effortless Attendance </span> , Every Time</h2>
                    <p>
                    Streamline attendance tracking with our intuitive app.
                    Efficiency and accuracy combined for seamless workforce management.
                    Make every minute count with our reliable attendance solution.
                    </p>
                </div>
            </div>
        </div>
    </section>
    

            <div id ="download" class="download-button pt-3">
    <a rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.sanedroid.attendance" target="_blank" class="text-white">
        <div class="playstore">
            <div class="card border-white rounded bg-green d-flex flex-row align-items-center justify-content-center px-2 text-center width:20">
                <div class="icon align-items-center">
                    <svg width="2rem" height="2rem" viewBox="0 0 16 16" class="bi bi-play-fill" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                    </svg>
                </div>
                <div class="content ml-1">
                    <small>Download on</small>
                    <h5>Google Play</h5>
                </div>
            </div>
        </div>
    </a>
</div>



        <div id="plan" class="bg-shade text-center mt-4 pt-5">
        <div class="container  pt-5">
            <div class="row">
                <div class="col-12 col-lg-8 m-auto">
                    <h2>Effortlessly manage attendance with<span class="text-green"> simplicity in mind!</span></h2>
                    <p>
                    Simplify attendance tracking with our user-friendly app.
                    Efficiently manage schedules and monitor attendance effortlessly.
                    Make managing your workforce a breeze with our intuitive solution.
                    </p>
                    <img class="mt-5 text-center" src={screenshotTwo} alt=""/>
                </div>
            </div>
        </div>
    </div>
  
    
        <section id="features2" class="mt-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6 col-md-6">
                    <img src={screenshotThree} alt=""/>
                </div>
                <div class="col-12 col-lg-6 col-md-6 d-flex flex-column my-auto">
                    <h2><span class="text-green">Effortless!</span> Reporting and Emailing </h2>
                    <p>
                    Generate comprehensive reports with ease and send them instantly via email.
                    Streamline your workflow by automating the process of report generation and distribution.
                    Save time and ensure accuracy with our efficient reporting and emailing feature
                    </p>
                </div>
            </div>
        </div>
    </section>
    
    <footer className="bg-dark text-light py-3 ">
    <div className="container">
      <div className="row">
        <div className="col-md-6 text-center">
          <h3>SANEDROID</h3>
          <p>Contact Us - sanedroid@gmail.com</p>
        </div>
        <div className="col-md-6 text-center">
          <p>
            <a href="https://sanedroidadmin.web.app/post/1432355448514282203" className="text-light">Privacy Policy</a>
          </p>
          <p>
            <a href="https://sanedroidadmin.web.app/post/3113186175720430126" className="text-light">Terms & Condition</a>
          </p>
          <p>
            <a href="attendanceplatform/delete_data" className="text-light">Delete Account</a>
          </p>
          <p>
            Copyright &copy;{new Date().getFullYear()} {' '}
             Attedance Platform powered by SANE DROID
          </p>
        </div>
      </div>
    </div>
  </footer>
    </div>

    
    </>
   
  )
}
